webpackJsonp([119000596891679],{

/***/ 384:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(706);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DragAndDropDemo = function (_React$Component) {
	  _inherits(DragAndDropDemo, _React$Component);
	
	  function DragAndDropDemo(props) {
	    _classCallCheck(this, DragAndDropDemo);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.handleMouseEvent = _this.handleMouseEvent.bind(_this);
	    return _this;
	  }
	
	  DragAndDropDemo.prototype.handleMouseEvent = function handleMouseEvent(e) {
	    e.persist();
	    this.props.scPromise.then(function (sc) {
	      return sc.gen(e.type, e);
	    });
	  };
	
	  DragAndDropDemo.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      {
	        className: 'drag-and-drop-example',
	        onMouseMove: this.handleMouseEvent
	      },
	      _react2.default.createElement(
	        'div',
	        {
	          className: 'rect',
	          onMouseDown: this.handleMouseEvent,
	          onMouseUp: this.handleMouseEvent,
	          style: {
	            left: (this.props.datamodel && this.props.datamodel.rectX) + 'px',
	            top: (this.props.datamodel && this.props.datamodel.rectY) + 'px'
	          } },
	        this.props.configuration && this.props.configuration[0]
	      )
	    );
	  };
	
	  return DragAndDropDemo;
	}(_react2.default.Component);
	
	exports.default = DragAndDropDemo;
	module.exports = exports['default'];

/***/ }),

/***/ 882:
/***/ (function(module, exports) {

	module.exports = "import React from 'react'\nimport './drag-and-drop-example.css';\n\nexport default class DragAndDropDemo extends React.Component {\n\n  constructor(props){\n    super(props);\n    this.handleMouseEvent = this.handleMouseEvent.bind(this);\n  }\n\n  handleMouseEvent(e){\n    e.persist();\n    this.props.scPromise.then( (sc) => sc.gen(e.type, e) )\n  }\n\n  render() {\n    return <div \n        className=\"drag-and-drop-example\"\n        onMouseMove={ this.handleMouseEvent }\n      >\n      <div \n        className=\"rect\"\n        onMouseDown={ this.handleMouseEvent }\n        onMouseUp={ this.handleMouseEvent }\n        style={{\n          left: `${this.props.datamodel && this.props.datamodel.rectX}px`,\n          top: `${this.props.datamodel && this.props.datamodel.rectY}px`\n        }}>\n          {this.props.configuration && this.props.configuration[0]}\n        </div>\n    </div>\n  }\n}\n"

/***/ }),

/***/ 706:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 883:
/***/ (function(module, exports) {

	module.exports = "<scxml \n    xmlns=\"http://www.w3.org/2005/07/scxml\"\n    version=\"1.0\">\n\n    <datamodel>\n        <data id=\"eventStamp\"/>\n        <data id=\"rectX\" expr=\"0\"/>\n        <data id=\"rectY\" expr=\"0\"/>\n        <data id=\"dx\"/>\n        <data id=\"dy\"/>\n    </datamodel>\n\n    <state id=\"idle\">\n        <transition event=\"mousedown\" target=\"dragging\">\n            <assign location=\"eventStamp\" expr=\"_event.data\"/>\n        </transition>\n    </state>\n\n    <state id=\"dragging\">\n        <transition event=\"mouseup\" target=\"idle\"/>\n        <transition event=\"mousemove\" target=\"dragging\">\n            <assign location=\"dx\" expr=\"eventStamp.clientX - _event.data.clientX\"/>\n            <assign location=\"dy\" expr=\"eventStamp.clientY - _event.data.clientY\"/>\n            <assign location=\"rectX\" expr=\"rectX - dx\"/>\n            <assign location=\"rectY\" expr=\"rectY - dy\"/>\n            <assign location=\"eventStamp\" expr=\"_event.data\"/>\n        </transition>\n    </state>\n\n</scxml>\n"

/***/ }),

/***/ 385:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.DragAndDropExample = exports.dragAndDropScxml = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _schviz = __webpack_require__(13);
	
	var _schviz2 = _interopRequireDefault(_schviz);
	
	var _dragAndDrop = __webpack_require__(883);
	
	var _dragAndDrop2 = _interopRequireDefault(_dragAndDrop);
	
	var _dragAndDropDemo = __webpack_require__(384);
	
	var _dragAndDropDemo2 = _interopRequireDefault(_dragAndDropDemo);
	
	var _dragAndDropDemo3 = __webpack_require__(882);
	
	var _dragAndDropDemo4 = _interopRequireDefault(_dragAndDropDemo3);
	
	var _components = __webpack_require__(68);
	
	var _common = __webpack_require__(39);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var dragAndDropScxml = exports.dragAndDropScxml = _dragAndDrop2.default;
	
	var DragAndDropExample = exports.DragAndDropExample = function (_SCComponent) {
	  _inherits(DragAndDropExample, _SCComponent);
	
	  function DragAndDropExample(props) {
	    _classCallCheck(this, DragAndDropExample);
	
	    return _possibleConstructorReturn(this, _SCComponent.call(this, props, dragAndDropScxml));
	  }
	
	  DragAndDropExample.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'table',
	        { style: { width: '100%', height: '400px' } },
	        _react2.default.createElement(
	          'tbody',
	          null,
	          _react2.default.createElement(
	            'tr',
	            null,
	            _react2.default.createElement(_common.Cell, {
	              contentHeight: '400px',
	              showSourceCode: this.state.showSourceCode,
	              sourceCode: _dragAndDropDemo4.default,
	              component: _react2.default.createElement(_dragAndDropDemo2.default, {
	                scPromise: this.scPromise,
	                configuration: this.state.configuration,
	                datamodel: this.state.datamodel
	              }),
	              caption: _react2.default.createElement(
	                'span',
	                null,
	                ' Click and drag the rectangle '
	              )
	            }),
	            _react2.default.createElement(_common.Cell, {
	              contentHeight: '400px',
	              showSourceCode: this.state.showSourceCode,
	              sourceCode: dragAndDropScxml,
	              component: _react2.default.createElement(_schviz2.default, {
	                scxmlDocumentString: dragAndDropScxml,
	                disableAnimation: true,
	                configuration: this.state && this.state.configuration,
	                disableZoomAnimation: true,
	                transitionsEnabled: this.state && this.state.transitionsEnabled,
	                expandAllStatesByDefault: true,
	                id: 'drag-and-drop'
	              }),
	              caption: _react2.default.createElement(
	                'span',
	                null,
	                'State machine'
	              )
	            })
	          )
	        )
	      ),
	      _react2.default.createElement(_components.ShowHideSourceCodeLink, { self: this })
	    );
	  };
	
	  return DragAndDropExample;
	}(_common.SCComponent);

/***/ }),

/***/ 426:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var React = _interopRequireWildcard(_react);
	
	var _TutorialPageWrapper = __webpack_require__(18);
	
	var _TutorialPageWrapper2 = _interopRequireDefault(_TutorialPageWrapper);
	
	var _dragAndDropExample = __webpack_require__(385);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var Introduction = function Introduction(_ref) {
	  var sectionName = _ref.sectionName,
	      by = _ref.by;
	  return React.createElement(
	    'div',
	    { className: 'container' },
	    React.createElement(
	      'h1',
	      null,
	      sectionName
	    ),
	    React.createElement(
	      'h6',
	      null,
	      by
	    ),
	    React.createElement(
	      'p',
	      null,
	      'Until now, we\u2019ve written SCXML that doesn\u2019t actually do anything. In the real world, when you transition to a new state UI elements need to be hidden or shown, or the appliance needs to sing a song, or the simulated character needs to use a different sprite. This chapter is about doing those things in SCXML.'
	    ),
	    React.createElement(
	      'p',
	      null,
	      'There are a few nodes that make this happen, and we\u2019ll introduce more later.'
	    ),
	    React.createElement(
	      'h2',
	      null,
	      ' ',
	      React.createElement(
	        'code',
	        null,
	        '<datamodel>'
	      ),
	      ' & ',
	      React.createElement(
	        'code',
	        null,
	        '<data>'
	      ),
	      ', and ',
	      React.createElement(
	        'code',
	        null,
	        '<assign>'
	      ),
	      ' & ',
	      React.createElement(
	        'code',
	        null,
	        '<script>'
	      ),
	      ' '
	    ),
	    React.createElement(
	      'p',
	      null,
	      'The ',
	      React.createElement(
	        'code',
	        null,
	        '<datamodel>'
	      ),
	      ' node with its children the ',
	      React.createElement(
	        'code',
	        null,
	        '<data>'
	      ),
	      ' nodes are used to define the namespaces the statechart can use to store information and functions. The statechart can then use ',
	      React.createElement(
	        'code',
	        null,
	        '<assign>'
	      ),
	      ' nodes to give those namespaces values and ',
	      React.createElement(
	        'code',
	        null,
	        '<script>'
	      ),
	      ' nodes to do something with those values.'
	    ),
	    React.createElement(
	      'p',
	      null,
	      'In this example we\u2019ll focus only on using ',
	      React.createElement(
	        'code',
	        null,
	        '<assign>'
	      ),
	      ' and ',
	      React.createElement(
	        'code',
	        null,
	        '<script>'
	      ),
	      ' nodes inside ',
	      React.createElement(
	        'code',
	        null,
	        '<transition>'
	      ),
	      ' nodes, though later we\u2019ll describe other ways they can be used.'
	    ),
	    React.createElement(
	      'p',
	      null,
	      'Here\u2019s a statechart that defines how the user can drag and drop an object:'
	    ),
	    React.createElement(_dragAndDropExample.DragAndDropExample, null),
	    React.createElement(
	      'p',
	      null,
	      'It\u2019s important to mention that any scripting in SCXML is ECMAScript (a.k.a. JavaScript).'
	    ),
	    React.createElement(
	      'p',
	      null,
	      React.createElement(
	        'code',
	        null,
	        '<assign>'
	      ),
	      ' uses two attributes, ',
	      React.createElement(
	        'code',
	        null,
	        'location'
	      ),
	      ' and ',
	      React.createElement(
	        'code',
	        null,
	        'expr'
	      ),
	      ', which define *in which name* to store *what*, respectively. All ',
	      React.createElement(
	        'code',
	        null,
	        'expr'
	      ),
	      ' attributes have to be expressions in ECMAScript, as if you were writing the right side of ',
	      React.createElement(
	        'code',
	        null,
	        'position = \u2026'
	      ),
	      '. Notice here the ',
	      React.createElement(
	        'code',
	        null,
	        'expr'
	      ),
	      ' attribute is used to define the initial value of the ',
	      React.createElement(
	        'code',
	        null,
	        '"position"'
	      ),
	      ' ',
	      React.createElement(
	        'code',
	        null,
	        '<data>'
	      ),
	      ' node as well as the values of both names in the ',
	      React.createElement(
	        'code',
	        null,
	        '<assign>'
	      ),
	      ' nodes.'
	    ),
	    React.createElement(
	      'p',
	      null,
	      'The SCXML interpreter makes one more namespace available to us, ',
	      React.createElement(
	        'code',
	        null,
	        '_event'
	      ),
	      '. When an event is fired on the interpreter, you can also pass a payload as ',
	      React.createElement(
	        'code',
	        null,
	        'data'
	      ),
	      ' (which is accessed through ',
	      React.createElement(
	        'code',
	        null,
	        '_event.data'
	      ),
	      '), so in this case we expect ',
	      React.createElement(
	        'code',
	        null,
	        'mousedown'
	      ),
	      ' and ',
	      React.createElement(
	        'code',
	        null,
	        'mousemove'
	      ),
	      ' to come with a payload that has two properties, ',
	      React.createElement(
	        'code',
	        null,
	        'x'
	      ),
	      ' and ',
	      React.createElement(
	        'code',
	        null,
	        'y'
	      ),
	      ', and we expect ',
	      React.createElement(
	        'code',
	        null,
	        'mousedown'
	      ),
	      ' to also include ',
	      React.createElement(
	        'code',
	        null,
	        'el'
	      ),
	      '.'
	    )
	  );
	};
	
	var WrappedIntroduction = function WrappedIntroduction(_ref2) {
	  var location = _ref2.location;
	  return React.createElement(_TutorialPageWrapper2.default, { Component: Introduction, pathname: location.pathname });
	};
	
	exports.default = WrappedIntroduction;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-tutorials-doing-with-scxml-js-4ea6857eab4873672c04.js